<template>
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Input v-model="projectDataLocal.projectInformation.projectName" placeholder="Project name" :viewMode="!canEdit" />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Input v-model="projectDataLocal.projectInformation.projectNumber" placeholder="Project No" :viewMode="!canEdit" />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Select :options="usersOptions" v-model="projectDataLocal.projectInformation.projectLeader" placeholder="Project leader" :viewMode="!canEdit" />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12" v-if="isNew || isCommonAdmin">
      <Radio
        v-model="projectDataLocal.projectInformation.projectStatus"
        :options="projectStatusOptions"
        placeholder="Project status"
        small
        :viewMode="!canEdit"
      />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12" v-else></div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Textarea v-model="projectDataLocal.projectInformation.projectDescription" placeholder="Project description" :viewMode="!canEdit" />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Select
        v-model="projectDataLocal.projectInformation.pdfType"
        :options="Object.values(PROJECT_PDF_TYPES)"
        placeholder="Project PDF"
        :viewMode="!canEdit"
      />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Input v-model="projectDataLocal.email" form-group-id="Report Recipient" placeholder="Report Recipient" :viewMode="!canEdit" />
    </div>
    <div class="col-lg-6 col-sm-12 col-xs-12">
      <Input
        v-model="projectDataLocal.emailCC"
        :tile-size="14"
        form-group-id="Report Recipient CC"
        placeholder="Report Recipient CC"
        :viewMode="!canEdit"
      />
    </div>
  </div>
</template>

<script>
import Input from '../../../../common/input';
import Textarea from '../../../../common/textarea';
import Select from '../../../../common/select';
import Radio from '../../../../common/radio';
import { PROJECT_PDF_TYPES } from '../../../../../../../../../constants';

export default {
  title: 'ProjectInformation',
  components: {
    Input,
    Select,
    Textarea,
    Radio,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
    isCommonAdmin: {
      type: Boolean,
      default: () => false,
    },
    isNew: {
      type: Boolean,
      default: () => false,
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
    usersOptions: {
      type: Array,
      default: () => [],
    },
    projectStatusOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      PROJECT_PDF_TYPES,
    };
  },
  computed: {
    projectDataLocal: {
      get: function () {
        return this.projectData;
      },
      set: function (value) {
        this.$emit('projectData', value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
